/**
 * Returns the first value that was actually provided.
 *
 * `null` and `undefined` are skipped. An empty string is a value and is
 * returned, so a blank field stays blank instead of falling through.
 *
 * @param values Candidates, in the order they should win.
 * @returns The first value that is not `null` or `undefined`, or `undefined`
 * when every candidate is missing.
 * @example
 * ```ts
 * firstDefined([null, undefined, 'Ada']); // 'Ada'
 * firstDefined(['', 'later']); // ''
 * firstDefined([null, undefined]); // undefined
 * ```
 */
export function firstDefined<T>(
  values: ReadonlyArray<T | null | undefined>,
): T | undefined {
  for (const value of values) {
    if (value != null) {
      return value;
    }
  }

  return undefined;
}
